import PopularPeople from "./PopularPeople";

export default PopularPeople;
